/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useCallback } from 'react';
import { NAVIGATION_ITEM } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/action-subject-type.tsx';
import { FIXED_ITEM } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { LEVEL_ONE } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { MENU_ID_FILTERS_SEARCH } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import type { NavSubmenuHeader } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { Nav4MenuLinkItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import type { JiraLinkConfig } from '@jira/platform__routing-router-components/src/ui/router-link-config/index.tsx';
import SearchIcon from '@atlaskit/icon/core/search';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import { SEARCH_ISSUES_HREF } from '../../constants.tsx';
import { useFilterActionsAnalytics } from '../../utils/analytics/index.tsx';

const searchAllIssues = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues',
	defaultMessage: 'Search issues',
	description: 'Message for the search all issues menu item in the filters submenu',
});

const searchAllIssuesIssueTermRefresh = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues-issue-term-refresh',
	defaultMessage: 'Search work items',
	description: 'Message for the search all issues menu item in the filters submenu',
});

export const Header: NavSubmenuHeader = ({ onClose }) => {
	const { formatMessage } = useIntl();
	const sendFilterAnalytics = useFilterActionsAnalytics();

	const handleOnClick = useCallback(
		(event: Event | React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>) => {
			sendFilterAnalytics(NAVIGATION_ITEM, {
				level: LEVEL_ONE,
				componentType: FIXED_ITEM,
				itemId: 'searchAllIssues',
			});
			onClose?.(event);
		},
		[onClose, sendFilterAnalytics],
	);

	return (
		<Nav4MenuLinkItem<JiraLinkConfig>
			href={SEARCH_ISSUES_HREF}
			onClick={handleOnClick}
			menuId={MENU_ID_FILTERS_SEARCH}
			elemBefore={<SearchIcon label="" color="currentColor" />}
		>
			{formatMessage(
				fg('jira-issue-terminology-refresh-m3') ? searchAllIssuesIssueTermRefresh : searchAllIssues,
			)}
		</Nav4MenuLinkItem>
	);
};
